import firebase from "firebase/app"

import "firebase/firestore"
import "firebase/storage"
import "firebase/auth"

// var config = {
//   apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
//   authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
//   databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
//   projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
//   storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
//   messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID
// }

const env = "asc_prod"
let config, api
if (env === "asc_dev") {
  config = {
    apiKey: "AIzaSyC4-C_yIGCDKHGBB94bsQEh8Ml6U0Iqgzc",
    authDomain: "asc-habit-five-percent-dev.firebaseapp.com",
    databaseURL: "https://asc-habit-five-percent-dev.firebaseio.com",
    projectId: "asc-habit-five-percent-dev",
    storageBucket: "asc-habit-five-percent-dev.appspot.com",
    messagingSenderId: "423246223821"
  }
  api = "https://us-central1-asc-habit-five-percent-dev.cloudfunctions.net"
  // api = "http://localhost:5000/asc-habit-five-percent-dev/us-central1"
} else if (env === "asc_prod") {
  config = {
    apiKey: "AIzaSyCqma9e1cxWSu05VFcQII69lTwASB0h4cA",
    authDomain: "asc-habit-five-percent-prod.firebaseapp.com",
    databaseURL: "https://asc-habit-five-percent-prod.firebaseio.com",
    projectId: "asc-habit-five-percent-prod",
    storageBucket: "asc-habit-five-percent-prod.appspot.com",
    messagingSenderId: "88482504887"
  }
  api = "https://us-central1-asc-habit-five-percent-prod.cloudfunctions.net"
} else if (env === "zauna_dev") {
  config = {
    apiKey: "AIzaSyAJCXQ_BJvscXm1IX6ts9weWlOaq9JwIh0",
    authDomain: "zauna-habit-five-percent-dev.firebaseapp.com",
    databaseURL: "https://zauna-habit-five-percent-dev.firebaseio.com",
    projectId: "zauna-habit-five-percent-dev",
    storageBucket: "zauna-habit-five-percent-dev.appspot.com",
    messagingSenderId: "266907366578"
  }
  api = "https://us-central1-asc-zauna-habit-five-percent-dev.cloudfunctions.net"
  // api = "http://localhost:5000/zauna-habit-five-percent-dev/us-central1"
} else if (env === "zauna_prod") {
  config = {
    apiKey: "AIzaSyC2kHbCAOsbukuNPHNMVl-31O4QG0UC5Bk",
    authDomain: "zauna-habit-five-percent-prod.firebaseapp.com",
    databaseURL: "https://zauna-habit-five-percent-prod.firebaseio.com",
    projectId: "zauna-habit-five-percent-prod",
    storageBucket: "zauna-habit-five-percent-prod.appspot.com",
    messagingSenderId: "266907366578"
  }
  api = "https://us-central1-zauna-habit-five-percent-prod.cloudfunctions.net"
}

const firebaseApp = firebase.initializeApp(config)

const strage = firebaseApp.storage()
const auth = firebaseApp.auth()
const firestore = firebaseApp.firestore()

export default firebaseApp.firestore()
// export {strage}
export { firestore, firebase, strage, auth, api, env }
